import { registry, userstate } from 'lcc-state';

import { DNode } from '@dojo/framework/core/interfaces';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { TopicProperties } from '@holmescorp/book-widgets/interfaces';

import css from '../css/topics.m.css';
import { Breadcrumbs, ContentContainer, Hero, Layout, LearnerTools, MCWhereYouLeftOff, OverallProgress } from './index';
import { MicroListView } from './list-view';
import { MicroProgress } from './progress';
import { ParentTree } from 'lcc-state/interfaces';

export interface TopicModuleProperties extends TopicProperties {}

const factory = create({ theme, userstate }).properties<TopicModuleProperties>();

export const TopicModule = factory(({ id: instanceId, properties, middleware: { theme, userstate } }): DNode => {
	const {
		topic: { children = [], attributes }
	} = properties();
	const themeCss = theme.classes(css);

	const id = 'topicmodule-wrapper';
	const widgetId = `${id}-${instanceId}`;

	const kids = children && children.filter((child) => !('shortdesc' in child)).map((child) => child.topicgroup);
	const status: ParentTree = userstate.get(userstate.path('status'));

	const topicgroups = kids
		? kids.map((tg) => ({
				attributes: tg.attributes,
				progress: status[tg.attributes?.key || ''].data
		  }))
		: [];
	const total = topicgroups.length;
	const complete = topicgroups.filter((tg) => tg.progress.complete === tg.progress.total).length;

	const label = v('span', {}, [`Reading Progress`]);

	return v('div', { id: `${id}-main` }, [
		v(
			'div',
			{
				id,
				widgetId,
				key: widgetId,
				xqa: `${id}-layout`
			},
			[
				w(Breadcrumbs, {}),
				w(
					Layout,
					{
						xqa: `${id}-layout-widget`,
						id: `${id}-layout-widget-${instanceId}`,
						key: `${id}-two-column-layout`
					},
					[
						{
							leading: [
								w(Hero, {}, [
									w(MCWhereYouLeftOff, { topicKey: attributes?.rel }),
									w(OverallProgress, {})
								]),
								w(MicroListView, {
									key: `${id}-list-view`,
									xqa: `${id}-list-view`,
									topics: kids,
									useImages: false,
									additionalClasses: [themeCss.list]
								})
							],
							trailing: [
								w(ContentContainer, {}, [
									w(MicroProgress, {
										max: total,
										value: complete,
										label
									})
								]),
								w(LearnerTools, {})
							]
						}
					]
				)
			]
		)
	]);
});

registry.define('MicroTopicModule', TopicModule);

export default TopicModule;
